import { getHttpClient } from '@/singleton-clients';

export interface LlmSettings {
	aiAssistant: {
		enabled: boolean;
	};
	llmServices: {
		enabled: boolean;
	};
	llmTerms: {
		accepted: boolean;
	};
	provider: string;
	baseUrl: string;
	model: string;
	apiKey?: string;
}

const LLM_SETTINGS_API_URL_PATH = 'api/v2/settings/ai/llm';

export async function getLlmSettings(): Promise<LlmSettings> {
	const httpClient = getHttpClient();
	const response = await httpClient.get<LlmSettings>(
		LLM_SETTINGS_API_URL_PATH,
	);
	if (!response) {
		throw new Error('Failed to load LLM settings');
	}
	return response;
}

export async function updateLlmSettings(
	settings: LlmSettings,
): Promise<LlmSettings> {
	const httpClient = getHttpClient();
	// Include all required fields for the API
	const apiPayload = {
		provider: settings.provider,
		model: settings.model,
		baseUrl: settings.baseUrl,
		apiKey: settings.apiKey || 'dummy-api-key', // API requires this field
		llmTerms: settings.llmTerms,
		llmServices: settings.llmServices,
		aiAssistant: settings.aiAssistant,
	};

	try {
		// The API returns an empty array on success
		await httpClient.post<any>(LLM_SETTINGS_API_URL_PATH, apiPayload);

		// Since the API doesn't return the settings object, return the original settings
		// This will likely need to be refreshed to get the actual state from the server
		return settings;
	} catch (error) {
		console.error('Error updating LLM settings:', error);
		throw error;
	}
}
